export default __webpack_public_path__ + "static/media/MOLA_elevation_key.05ac9e5f.png";